import Vue from "vue";
import store from "./store";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Valve from "./views/Valve.vue";
import Search from "./views/Search.vue";
import Search2 from "./views/Search2.vue";
import Application from "./views/Application.vue";
import Brands from "./views/Brands.vue";
import Product from "./views/Product.vue";
import Brand from "./views/Brand.vue";
import DownloadQuery from "./views/DownloadQuery.vue";
import BrandDownload from "./views/BrandDownload.vue";
import BrandDownloadNew from "./views/BrandDownloadNew.vue";
import Contact from "./views/Contact.vue";
import ContactForm from "./views/ContactForm.vue";
import DeviceRegistration from "./views/DeviceRegistration.vue";
import Registration from "./views/Registration.vue";
import Tools from "./views/Tools.vue";
import Main from "./views/Main.vue";
import Sitemap from "./views/Sitemap.vue";
import { wechatLogin } from "@/api/request";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/search",
      name: "search",
      component: Search,
    },
    {
      path: "/search2",
      name: "search2",
      component: Search2,
    },
    {
      path: "/download",
      name: "download-query",
      component: DownloadQuery,
    },
    {
      path: "/brand/:id",
      name: "brand-download",
      component: BrandDownload,
    },
    {
      path: "/brandnew/:id",
      name: "brand-download-new",
      component: BrandDownloadNew,
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
    },
    {
      path: "/form",
      name: "form",
      component: ContactForm,
    },
    {
      path: "/product",
      name: "product",
      component: Product,
    },
    {
      path: "/tools",
      name: "tools",
      component: Tools,
    },
    {
      path: "/main",
      name: "main",
      component: Main,
    },
    {
      path: "/brands",
      name: "brands",
      component: Brands,
    },
    {
      path: "/brands/:id",
      name: "brand",
      component: Brand,
    },
    {
      path: "/applications/:id",
      name: "application",
      component: Application,
    },
    {
      path: "/sitemap",
      name: "sitemap",
      component: Sitemap,
    },
    {
      path: "/valve",
      name: "valve",
      component: Valve,
    },
    {
      path: "/device-reg",
      name: "device-reg",
      component: DeviceRegistration,
    },
    {
      path: "/reg",
      name: "reg",
      component: Registration,
    },
    {
      path: "*",
      name: "home",
      component: Home,
    },
  ],
});

router.beforeEach(async (to, _from, next) => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");
  if (to.path == "/device-reg") {
    store.dispatch("change_float", false);
  } else {
    store.dispatch("change_float", true);
  }
  if (code && code != "") {
    try {
      const res = await wechatLogin({
        code,
        state: urlParams.get("state"),
      });
      console.log(res.data);
      localStorage.setItem("spx-token", res.data.token);
      location.replace("https://itt-ft.effective-wechat.com/query/#" + to.path);
    } catch (error) {
      location.replace("https://itt-ft.effective-wechat.com/query/#" + to.path);
    }
    const query = Object.assign({}, to.query);
    delete query.code;
    delete query.state;
  } else {
    next();
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
